import React from 'react';
import ReactDOM from 'react-dom';
import EventEmitter from 'eventemitter3';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SentryInit } from '@/utils';
import '@/locale/i18n';
import '@/style';

window.Buffer = window.Buffer || require('buffer').Buffer;
window.EVENT = new EventEmitter();
SentryInit();

const render = () => {
  ReactDOM.render(<App />, document.getElementById('root') as HTMLElement);
};

if (MOCK_SERVER) {
  // eslint-disable-next-line
  const { worker } = require('./mocks/index');
  worker.start({
    onUnhandledRequest: 'bypass',
  });

  setTimeout(() => {
    render();
  }, 300);
} else {
  render();
}

// eslint-disable-next-line
if (process.env.NODE_ENV === 'development' && (module as any).hot) {
  // eslint-disable-next-line
  (module as any).hot.accept('./App', () => {
    render();
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
